module.exports = __webpack_public_path__ + "img/Piano.5917bd6f.jpg";